<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="hotelRefundableObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>

            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">Refundability</p>
                    <p>Trigger for room rates that are <span class="rule-config-variable" @click="isEdit = !isEdit">
                            {{ boolToStr(hotelRefundableObj.value) }}
                            <b-icon icon="pencil" size="is-small"></b-icon>
                        </span>
                    </p>
                </div>
                <div class="allbtns">
                    <b-switch :rounded="true" :value="hotelRefundableObj.isActive" v-model="hotelRefundableObj.isActive"
                        @input="hotelRefundable" :left-label="true">{{ hotelRefundableObj.isActive ? 'Active' : 'Inactive' }}
                    </b-switch>
                </div>
            </div>
        </div>
        <div v-if="isEdit" class="edittravelpolicy editTravel2">
            <HotelRefundable :refundableVal="refundableVal" @emitData="getValue" />
            <b-button @click="saveCall">SAVE</b-button>
        </div>
    </div>
</template>
<script>
import HotelRefundable from "../CommonRules/HotelRefundable.vue";
export default {
    name: "",
    props: {
        value: {
            type: [Object],
        },
    },
    components: { HotelRefundable },
    data() {
        return {
            refundableVal: false,
            hotelRefundableObj: this.value
                ? this.value
                : {
                    name: "hotelNonRefundable",
                    isActive: false,
                    type: "hotel",
                    message: "Trigger if rate is refundable.",
                    value: false
                },
            isEdit: false,
            emitedValue: null
        };
    },
    methods: {
        hotelRefundable() {
            this.$emit("hotelRefundable", this.hotelRefundableObj);
        },
        getValue(val) {
            this.emitedValue = val;
        },
        saveCall() {
            this.isEdit = false;
            this.hotelRefundableObj.value = this.emitedValue;
        },
        boolToStr(bool){
            if(bool == true){
                return  'Non-Refundable'
            }else{
                return 'Refundable'
            }
        }
    },
    mounted() {
        this.hotelRefundableObj.type = "hotel";
        this.hotelRefundableObj.message = "Trigger if rate is " + this.boolToStr(this.hotelRefundableObj.value);
        this.$emit("hotelRefundable", this.hotelRefundableObj);
    },
    computed: {
        typOfFlights() {
            if (this.hotelRefundableObj.value) {
                return 'Non-Refundable'
            } 
            return 'Refundable'
        },
    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                if (this.value) {
                    const hotelProps = this.value;
                    this.hotelRefundableObj = hotelProps
                    this.refundableVal = hotelProps.value;
                    
                }
                this.hotelRefundableObj.type = "hotel";
                this.hotelRefundableObj.message = "Trigger if rate is " + this.boolToStr(this.hotelRefundableObj.value);
                this.$emit("hotelRefundable", this.hotelRefundableObj);

            },
            deep: true,
        },
    },
};
</script>
  